<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
  <span style="color: #FF0202;">{{'alert.error' | translate}}</span>
  <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<div class="row mt-4">
  <div class="col-12">
    <div [innerHTML]="message | translate" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;"></div>
  </div>
</div>


<div mat-dialog-actions class="justify-content-end">

  <!--build icon, set default cancel-->
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{'button.close' | translate}}
  </button>
</div>
